import React, { useEffect } from "react";
import Footer from "../../Shared/Footer/Footer";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import AboutBanner from "../AboutBanner/AboutBanner";
import CommunicationInfo from "../CommunicationInfor/CommunicationInfo";
import HardwareResource from "../HardwareResource/HardwareResource";
import InformationTechnology from "../InformationTechnology/InformationTechnology";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <NavigationBar />
      <AboutBanner />
      <HardwareResource />
      <InformationTechnology />
      <CommunicationInfo />
      <Footer />
    </div>
  );
};

export default AboutUs;
